import clsx from "clsx";
import { ReactElement, useState } from "react";
import { ShowLessArrow } from "../../../../../assets";
import { Card } from "../../../../../components";
import { getGatewayScoreColorAndDesc } from "../../utils";
import { CookieLogoIcon } from "./CookieLogoIcon";

interface ExpandableCardProps {
  title: string;
  shownByDefault?: boolean;
  gatewayScore?: number;
  poweredByCookie?: boolean;
  children: ReactElement | string;
  className?: string;
}

export const ExpandableCard = ({
  title,
  shownByDefault = true,
  gatewayScore,
  poweredByCookie,
  children,
  className = "",
}: ExpandableCardProps) => {
  const [isVisible, setIsVisible] = useState(shownByDefault);

  const { color: gatewayScoreBgColor, desc: gatewayScoreDesc } =
    getGatewayScoreColorAndDesc(gatewayScore);

  return (
    <Card className={`${className} relative p4 lg:p-5`} size="large">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="watermark"></div>
      </div>

      <div className="relative flex flex-col gap-[30px] w-full">
        <div className="flex justify-between">
          <div className="flex items-center gap-4 flex-wrap">
            <h2 className="font-bold">{title}</h2>
            {gatewayScore && (
              <div
                className={clsx(
                  "flex gap-1 max-w-[240px] px-5 py-2 items-end rounded-md text-white font-bold",
                  gatewayScoreBgColor && `bg-[${gatewayScoreBgColor}]`,
                )}
              >
                <span className="text-xs opacity-50 font-normal">
                  Gateway score:
                </span>
                <span className="font-medium">{gatewayScore}</span>
                <span className="text-[10px] font-normal">
                  ({gatewayScoreDesc})
                </span>
              </div>
            )}
            {poweredByCookie && (
              <div className="flex items-center gap-1 rounded-lg px-2 py-1 bg-[rgba(199,245,211,1)] text-black font-medium text-xs">
                <div>Powered by</div>
                <CookieLogoIcon />
                <div>Cookie</div>
              </div>
            )}
          </div>

          <button
            className="flex gap-2 items-center cursor-pointer select-none"
            onClick={() => {
              setIsVisible((prev) => !prev);
            }}
          >
            <p className="text-[#007DFF]">
              {isVisible ? "Hide details" : "Show details"}
            </p>
            <ShowLessArrow
              className={`${!isVisible && "rotate-180"} transition-all`}
            />
          </button>
        </div>
        <div className={`${isVisible ? "" : "hidden"}`}>{children}</div>
      </div>
    </Card>
  );
};
